import React from 'react';
import { CalendarDays, LayoutGrid, List, MessageSquare, Mic } from 'lucide-react';
import { t } from '../../lib/i18n';

export type MobileTab = 'home' | 'calendar' | 'chat' | 'more';

interface MobileTabBarProps {
  active: MobileTab | null;
  onNavigate: (tab: MobileTab) => void;
  /** Ortadaki düğme: kayıt yoksa kayıt seçenekleri, kayıt sürüyorsa kayıt ekranı. */
  onRecord: () => void;
  isRecording: boolean;
}

/**
 * Telefonun ana menüsü: masaüstündeki kenar çubuğunun yerine alttaki sekmeler.
 * Ortada, başparmağın eriştiği yerde kayıt düğmesi.
 */
export const MobileTabBar: React.FC<MobileTabBarProps> = ({ active, onNavigate, onRecord, isRecording }) => {
  const tab = (id: MobileTab, label: string, Icon: typeof List) => {
    const isActive = active === id;
    return (
      <button
        type="button"
        onClick={() => onNavigate(id)}
        aria-current={isActive ? 'page' : undefined}
        data-tour={`tab-${id}`}
        data-tab={id}
        className={`min-w-0 h-[54px] flex flex-col items-center justify-center gap-[3px] text-[11.5px] font-semibold transition-colors active:opacity-70 ${
          isActive ? 'text-brand-text' : 'text-muted-foreground'
        }`}
      >
        <Icon className="w-[22px] h-[22px] shrink-0" strokeWidth={1.8} />
        {/* Büyük yazı tipi ayarında dar telefonda komşu sekmeye taşmasın. */}
        <span className="max-w-full px-0.5 truncate">{label}</span>
      </button>
    );
  };

  return (
    <nav
      aria-label={t('Ana menü', 'Main menu')}
      className="shrink-0 grid grid-cols-5 items-center px-2 pt-1.5 pb-2 border-t border-border bg-background/90 backdrop-blur-xl select-none"
    >
      {tab('home', t('Toplantılar', 'Meetings'), List)}
      {tab('calendar', t('Takvim', 'Calendar'), CalendarDays)}
      <div className="flex justify-center">
        <button
          type="button"
          onClick={onRecord}
          aria-label={isRecording ? t('Süren kayda dön', 'Back to the recording') : t('Yeni kayıt', 'New recording')}
          data-tour="record"
          className={`-mt-6 w-[60px] h-[60px] rounded-full flex items-center justify-center border-4 border-background shadow-lg shadow-black/30 transition-transform active:scale-95 ${
            isRecording ? 'bg-record text-white animate-pulse' : 'bg-brand text-on-brand'
          }`}
        >
          <Mic className="w-[26px] h-[26px]" strokeWidth={1.9} />
        </button>
      </div>
      {tab('chat', t('Sohbet', 'Chat'), MessageSquare)}
      {tab('more', t('Daha fazla', 'More'), LayoutGrid)}
    </nav>
  );
};
